import React from 'react';
import css from './ListingPageGo.css';
import { PropertyCheckList } from '../../../components';
import { FormattedMessage } from 'react-intl';

const SectionFeaturesMaybe = props => {
  const { listing, keyFeaturesConfig } = props;
  const { keyFeatures } = listing.attributes.publicData || {};
  return (
    <div className={css.section}>
      <div className={css.sectionTitle}>
        <FormattedMessage id="ListingPageGo.SectionFeatures.title" />
      </div>
      <PropertyCheckList
        id="ahihi"
        options={keyFeaturesConfig}
        selectedOptions={keyFeatures}
        twoColumns={true}
        className={css.features}
      />
    </div>
  );
};

export default SectionFeaturesMaybe;
